/* eslint-disable @typescript-eslint/no-explicit-any */
import { SchemaContent } from '@/types/schema'
import { getImageUrl } from './util'

/**
 * Generate organization schema
 */
export function generateOrganizationSchema(): Record<string, any> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    image: 'https://www.coolmate.me/images/logo-mobile.png',
    url: 'https://www.coolmate.me',
    sameAs: [
      'https://www.facebook.com/coolmate.me/',
      'https://instagram.com/coolmate.me',
      'https://www.tiktok.com/@cool.coolmate',
      'https://www.youtube.com/@coolmate1897',
      'https://www.linkedin.com/company/coolmate',
    ],
    logo: 'https://www.coolmate.me/images/logo-mobile.png',
    name: 'COOLMATE',
    legalName: 'FASTECH ASIA',
    description:
      'Coolmate là thương hiệu thời trang nam trực tuyến tại Việt Nam, với sứ mệnh đơn giản hóa trải nghiệm mua sắm quần áo cho phái mạnh. Thay vì phải vật lộn với vô vàn lựa chọn, Coolmate mang đến giải pháp mua sắm tiện lợi, tập trung vào chất lượng, giá cả hợp lý và dịch vụ khách hàng tận tâm. Thương hiệu cung cấp các sản phẩm thời trang nam thiết yếu như áo thun, quần short, quần lót, áo polo và phụ kiện, với chất liệu cao cấp như cotton Pima, Modal, Bamboo, mang đến cảm giác thoải mái tối ưu. Thiết kế tối giản, dễ phối hợp, phù hợp với nhiều phong cách và hoàn cảnh. Mua sắm trên Coolmate vô cùng dễ dàng với giao diện website thân thiện, chính sách đổi trả linh hoạt mang đến sự an tâm cho khách hàng. Dịch vụ chăm sóc khách hàng tận tâm luôn sẵn sàng hỗ trợ và giải đáp mọi thắc mắc. Coolmate không chỉ là nơi mua sắm quần áo, mà còn là người bạn đồng hành tin cậy, giúp nam giới tự tin thể hiện phong cách riêng mà không cần tốn quá nhiều thời gian, công sức và chi phí',
    email: 'cool@coolmate.me',
    numberOfEmployees: {
      '@type': 'QuantitativeValue',
      minValue: 150,
      maxValue: 200,
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: ['+84-1900-272737', '+84-28-7777-2737'],
      openingHours: 'Mo,Tu,We,Th,Fr,Sa,Su 08:30-22:00',
      areaServed: 'VN',
      availableLanguage: ['EN', 'VI'],
    },
    address: [
      {
        '@type': 'PostalAddress',
        streetAddress:
          'Tầng 3-4, Tòa nhà BMM, Km2, Đường Phùng Hưng, Phường Hà Đông, Thành phố Hà Nội, Việt Nam',
        addressLocality: 'Hà Nội',
        postalCode: '100000',
        addressCountry: 'VN',
      },
      {
        streetAddress:
          'Lô C3, đường D2, KCN Cát Lái, Thạnh Mỹ Lợi, TP. Thủ Đức, TP. Hồ Chí Minh',
        addressLocality: 'Thành phố Hồ Chí Minh',
        postalCode: '700000',
        addressCountry: 'VN',
      },
    ],
    founders: [
      {
        '@type': 'Person',
        name: 'Phạm Chí Nhu',
        url: 'https://www.coolmate.me/post/CEO-Coolmate-la-ai',
        email: 'nhu@coolmate.me',
        jobTitle: {
          '@type': 'DefinedTerm',
          name: 'Chief Executives Officer',
          description:
            'CEO (giám đốc điều hành) là người nắm giữ vị trí điều hành cao nhất, chịu trách nhiệm cuối cùng về mọi hoạt động và hiệu quả kinh doanh của doanh nghiệp. CEO định hướng chiến lược dài hạn, đưa ra các quyết định quan trọng, phân bổ nguồn lực hiệu quả để dẫn dắt doanh nghiệp đến thành công. CEO truyền cảm hứng và định hình văn hóa doanh nghiệp, xây dựng đội ngũ lãnh đạo vững mạnh, thúc đẩy sự đổi mới và phát triển bền vững',
        },
      },
      {
        '@type': 'Person',
        name: 'Nguyễn Hoài Xuân Lan',
        url: 'https://www.linkedin.com/in/xuanlannguyen',
        email: 'lan@coolmate.me',
        jobTitle: {
          '@type': 'DefinedTerm',
          name: 'Chief Marketing Officer',
          description:
            'CMO (giám đốc marketing) chịu trách nhiệm xây dựng, phát triển và quản lý hình ảnh thương hiệu nhất quán và thu hút trên mọi điểm chạm với khách hàng. CMO phân tích thị trường, nắm bắt insight khách hàng để xây dựng chiến lược marketing hiệu quả, đưa sản phẩm/dịch vụ đến gần hơn với khách hàng mục tiêu. CMO cũng là người lãnh đạo, điều phối các hoạt động marketing đa kênh, tối ưu hóa hiệu quả và ngân sách, đảm bảo đạt được mục tiêu kinh doanh của doanh nghiệp',
        },
      },
      {
        '@type': 'Person',
        name: 'Nguyễn Văn Hiệp',
        url: 'https://www.linkedin.com/in/erik-nguyen',
        email: 'hiep@coolmate.me',
        jobTitle: {
          '@type': 'DefinedTerm',
          name: 'Chief Technology Officer',
          description:
            'CTO (giám đốc công nghệ) là người định hướng và dẫn dắt chiến lược công nghệ cho doanh nghiệp, đảm bảo hệ thống công nghệ phù hợp với tầm nhìn và mục tiêu phát triển. CTO nghiên cứu, ứng dụng công nghệ mới, xây dựng hệ thống hạ tầng công nghệ vững chắc, tối ưu hóa quy trình vận hành, gia tăng hiệu suất hoạt động cho doanh nghiệp. CTO cũng là người dẫn dắt đội ngũ kỹ sư, phát triển các giải pháp, sản phẩm công nghệ đột phá, nâng cao năng lực cạnh tranh cho doanh nghiệp trong thời đại số',
        },
      },
    ],
    foundingDate: '2024-03-01',
    vatID: '0108617038',
  }
}

/**
 * Generate website schema with search action
 */
export function generateWebsiteSchema(): Record<string, any> {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: 'https://www.coolmate.me',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate:
          'https://www.coolmate.me/spotlight?search={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  }
}

/**
 * Generate breadcrumb schema
 */
export function generateBreadcrumbSchema(
  routeName: string,
  content?: SchemaContent
): Record<string, any> {
  // Start with home
  const breadcrumbItems = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Trang chủ',
      item: 'https://www.coolmate.me',
    },
  ]
  // Add route-specific items
  if (routeName === 'about-us') {
    breadcrumbItems.push({
      '@type': 'ListItem',
      position: 2,
      name: 'Câu chuyện về Coolmate',
      item: 'https://www.coolmate.me/about-us',
    })
  } else if (routeName === 'blog') {
    breadcrumbItems.push({
      '@type': 'ListItem',
      position: 2,
      name: 'Blog',
      item: 'https://www.coolmate.me/blog',
    })
  } else if (routeName === 'size-chart') {
    breadcrumbItems.push({
      '@type': 'ListItem',
      position: 2,
      name: 'Bảng size chuẩn',
      item: 'https://www.coolmate.me/size-chart',
    })
  } else if (routeName === 'builder') {
    breadcrumbItems.push({
      '@type': 'ListItem',
      position: 2,
      name: 'Tạo Basic Box',
      item: 'https://www.coolmate.me/builder',
    })
  } else if (routeName === 'medium-box') {
    breadcrumbItems.push({
      '@type': 'ListItem',
      position: 2,
      name: 'Tạo CoolBox',
      item: 'https://www.coolmate.me/medium-box',
    })
  } else if (routeName === 'large-box') {
    breadcrumbItems.push({
      '@type': 'ListItem',
      position: 2,
      name: 'Tạo Supper CoolBox',
      item: 'https://www.coolmate.me/large-box',
    })
  } else if (routeName === 'filter.index') {
    breadcrumbItems.push({
      '@type': 'ListItem',
      position: 2,
      name: 'Sản phẩm',
      item: 'https://www.coolmate.me/filter',
    })
  } else if (
    routeName === 'collection' &&
    content?.title &&
    content?.seo_alias
  ) {
    if (content?.breadcrumbs?.length) {
      content?.breadcrumbs.forEach((item, index) => {
        breadcrumbItems.push({
          '@type': 'ListItem',
          position: index + 2,
          name: item.title,
          item: item.href
            ? `https://www.coolmate.me${item.href}`
            : `https://www.coolmate.me/collection/${content.seo_alias}`,
        })
      })
    } else {
      breadcrumbItems.push({
        '@type': 'ListItem',
        position: 2,
        name: content.title,
        item: `https://www.coolmate.me/collection/${content.seo_alias}`,
      })
    }
  } else if (
    (routeName === '84rising' || routeName === 'cm24') &&
    content?.title &&
    content?.seo_alias
  ) {
    breadcrumbItems.push({
      '@type': 'ListItem',
      position: 2,
      name: content.title,
      item: `https://www.coolmate.me/collection/${content.seo_alias}`,
    })
  } else if (
    routeName === 'page-detail' &&
    content?.title &&
    content?.seo_alias
  ) {
    breadcrumbItems.push({
      '@type': 'ListItem',
      position: 2,
      name: content.title,
      item: `https://www.coolmate.me/page/${content.seo_alias}`,
    })
  } else if (
    routeName === 'campaign-detail' &&
    content?.title &&
    content?.seo_alias
  ) {
    breadcrumbItems.push({
      '@type': 'ListItem',
      position: 2,
      name: content.title,
      item: `https://www.coolmate.me/campaign/${content.seo_alias}`,
    })
  } else if (
    routeName === 'product' &&
    content?.collections?.[0]?.label &&
    content?.collections?.[0]?.seo_alias &&
    content?.breadcrumbs?.length
  ) {
    content?.breadcrumbs.forEach((item, index) => {
      breadcrumbItems.push({
        '@type': 'ListItem',
        position: index + 2,
        name: item.title,
        item: item.href
          ? `https://www.coolmate.me${item.href}`
          : `https://www.coolmate.me/product/${content?.collections?.[0]?.seo_alias}`,
      })
    })
  } else if (
    routeName === 'blog.detail' &&
    content?.title &&
    content?.seo_alias
  ) {
    breadcrumbItems.push(
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Góc mặc đẹp',
        item: 'https://www.coolmate.me/blog',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: content.title,
        item: `https://www.coolmate.me/blog/${content.seo_alias}`,
      }
    )
  } else if (routeName === 'single-article' && content) {
    breadcrumbItems.push({
      '@type': 'ListItem',
      position: 2,
      name: 'Góc mặc đẹp',
      item: 'https://www.coolmate.me/blog',
    })

    if (content?.blog?.title && content?.blog?.seo_alias) {
      breadcrumbItems.push(
        {
          '@type': 'ListItem',
          position: 3,
          name: content.blog.title,
          item: `https://www.coolmate.me/blog/${content.blog.seo_alias}`,
        },
        {
          '@type': 'ListItem',
          position: 4,
          name: content.title || '',
          item: `https://www.coolmate.me/post/${content.seo_alias || ''}`,
        }
      )
    } else {
      breadcrumbItems.push({
        '@type': 'ListItem',
        position: 3,
        name: content.title || '',
        item: `https://www.coolmate.me/post/${content.seo_alias || ''}`,
      })
    }
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItems,
  }
}

/**
 * Generate product schema
 */
export function generateProductSchema(
  content: SchemaContent
): Record<string, any> {
  // Extract images
  const images = content.images
    ? content.images.map((img) => getImageUrl(img.src))
    : []

  // Base schema
  const schema: Record<string, any> = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: content.title || '',
    description: content.seo_description || '',
    image: images,
    brand: {
      '@type': 'Brand',
      name: 'Coolmate',
    },
    offers: {
      '@type': 'Offer',
      url: `https://www.coolmate.me/product/${content.seo_alias || ''}`,
      priceCurrency: 'VND',
      price: content.price || 0,
      itemCondition: 'https://schema.org/NewCondition',
      availability: content.in_stock
        ? 'https://schema.org/InStock'
        : 'https://schema.org/OutOfStock',
    },
  }

  // Add review aggregation if available
  if (content.review && content.review.count > 0) {
    schema.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: (Math.round((content.review.avg / 2) * 10) / 10).toString(),
      reviewCount: content.review.count.toString(),
    }
  }

  return schema
}

/**
 * Generate collection page schema
 */
export function generateCollectionSchema(
  content: SchemaContent
): Record<string, any> {
  // Extract images
  const images = content.images
    ? content.images.map((img) => getImageUrl(img.src))
    : []

  return {
    '@context': 'https://schema.org/',
    '@type': 'CollectionPage',
    name: content.title || '',
    url: `https://www.coolmate.me/collection/${content.seo_alias || ''}`,
    about: {
      '@type': 'WebPage',
      offers: {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Product',
          name: content.title || '',
          url: `https://www.coolmate.me/collection/${content.seo_alias || ''}`,
          image: images.length ? images : undefined,
          PeopleAudience: {
            suggestedGender:
              content.gender === 'female'
                ? 'https://schema.org/Female'
                : 'https://schema.org/Male',
          },
          brand: {
            '@type': 'Brand',
            name: 'Coolmate',
            id: 'https://www.coolmate.me/#Organization',
            url: 'https://www.coolmate.me/',
          },
          ...(content.review && {
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: (content.review.avg / 2).toFixed(1),
              reviewCount: content.review.count,
            },
          }),
        },
      },
    },
  }
}

/**
 * Generate product catalog schema for category pages
 */
export function generateProductCatalogSchema(
  content: SchemaContent
): Record<string, any> {
  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: content.seo_meta_title || 'Coolmate',
    image: 'https://www.coolmate.me/images/logo-mobile.png',
    description: content.seo_description || 'Coolmate',
    brand: {
      '@type': 'Brand',
      name: 'Coolmate',
    },
    offers: {
      '@type': 'AggregateOffer',
      offerCount: '5',
      lowPrice: '49000',
      highPrice: '599000',
      priceCurrency: 'VND',
      itemCondition: 'https://schema.org/NewCondition',
      availability: 'https://schema.org/InStock',
      seller: { '@id': 'https://coolmate.me#Organization' },
    },
  }
}

/**
 * Generate news article schema
 */
export function generateNewsArticleSchema(
  content: SchemaContent
): Record<string, any> {
  // Extract first image if available
  const imageUrl =
    content.images && content.images.length > 0
      ? getImageUrl(content.images[0].src, '100_113')
      : ''

  return {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://coolmate.me/post/${content.seo_alias || ''}#article`,
    },
    headline: content.title || '',
    image: [imageUrl],
    datePublished: content.created_at || '',
    dateModified: content.modified_date || content.created_at || '',
    author: {
      '@type': 'Person',
      name: 'Admin',
    },
    publisher: {
      '@type': 'Organization',
      id: 'https://coolmate.me#Organization',
      name: 'Coolmate',
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.coolmate.me/images/logo.png',
      },
    },
    description: content.seo_description || '',
  }
}
